import { Calendar } from "lucide-react"
import { VideoIcon } from "lucide-react"
import { Link } from "react-router-dom"

export function FixedAppointmentButtons() {
  return (
    <div className="flex fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t shadow-lg">
      <Link 
        to="/book-now"
        className="flex items-center justify-center gap-2 text-white py-4 hover:opacity-90 transition-colors w-[50%]"
        style={{ backgroundColor: '#a52a2a' }}
      >
        <Calendar className="w-5 h-5" />
        <span className="font-medium">Book Appointment</span>
      </Link>
      <Link 
        to="/video-consultation"
        className="flex items-center justify-center gap-2 text-white py-4 hover:opacity-90 transition-colors w-[50%]"
        style={{ backgroundColor: '#424242ff' }}
      >
        <VideoIcon className="w-5 h-5" />
        <span className="font-medium">Video Consultation</span>
      </Link>
    </div>
  )
}
